import { formatMoney } from "@stackline/ui";

import FlowContainer from "../../components/FlowContainer";
import { useSurvey } from "./SurveyProvider";

import { useEffect } from "react";
import { useTrackActions } from "../../../../../../utils/hooks/useTracking";
import { AnalyticsTrackingEvent } from "@brandclub/common-ui";
import RewardFlowFinishButtons from "../../components/RewardFlowFinishButtons";
import { useSiteBrandingType } from "@/components/SiteProvider";
import { SiteBrandingType } from "@/types/misc";
import { StoreFinish } from "@/components/StoreComponents/StoreFinish";

const Finish = () => {
  const siteBrandingType = useSiteBrandingType();
  const isDTC = siteBrandingType === SiteBrandingType.CustomDTCStore;
  const { survey, receivedReward } = useSurvey();

  const [trackAction] = useTrackActions();

  const brandName = survey?.brandclub?.name;
  const brandId = survey?.brandclub?.brandId;

  useEffect(() => {
    trackAction(AnalyticsTrackingEvent.COMPLETED_SURVEY, {
      ...(survey.brandclub || {}),
      surveyId: survey?.extendedAttributes?.surveyId,
      rewardAmount: survey?.extendedAttributes?.reward?.reward?.amount,
      campaignId: survey?.campaignId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FlowContainer>
      <StoreFinish
        title="Thank you"
        subtitle={`We appreciate your feedback. ${
          receivedReward > 0
            ? `You earned a ${formatMoney(
                receivedReward
              )} reward that will be unlocked with your next purchase.`
            : ""
        }`}
        confettiProps={{ brandId: isDTC ? brandId : undefined }}
      >
        <RewardFlowFinishButtons brandName={brandName} brandId={brandId} />
      </StoreFinish>
    </FlowContainer>
  );
};

export default Finish;
